import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import React, { Dispatch, SetStateAction, useState } from "react";
import LanguageIcon from "@mui/icons-material/Language";
import { staticTextMap, Translations } from "../models/language.model";
import iso from "iso-639-1";
import { HtmlDetailData } from "../models/base.model";

export function SwitchLanguageButton(props: {
  setLanguage: Dispatch<SetStateAction<string>>;
  availableLanguages: string[];
}) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box>
      <IconButton onClick={handleClick} sx={{ p: 0 }}>
        <LanguageIcon />
      </IconButton>
      <Menu
        slotProps={{
          paper: {
            style: {
              maxHeight: "50vh",
            },
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {props.availableLanguages.map((l: string) => (
          <MenuItem
            key={l}
            onClick={() => {
              props.setLanguage(l);
              handleClose();
            }}
          >
            {iso.getNativeName(l)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

export const localized = <T extends string | HtmlDetailData>(
  lan: string,
  obj: { translations?: Translations },
  key: string,
  fallback: T
): T => {
  return (obj?.translations?.[lan]?.[key] as T) || fallback;
};

export const localizedUI = (lan: string, key: string): string => {
  return staticTextMap[lan]?.[key] || staticTextMap["en"][key] || key;
};
